import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface BathProps {
    readOnly?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Bath: React.FC<BathProps> = ({ readOnly = false, propertyGuid, isReview = false }) => {
    const [bath, setBath] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Additional Features']?.['Bath'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Additional Features': { ...s.values?.['Additional Features'], Bath: v } } })
    );
    const label = 'Bath';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={bath}
                />
            ) : (
                <TextBox
                    value={bath ?? ''}
                    onChange={(value) => setBath(value)}
                    label={label}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
